<template>
  <svg
    v-if="icon === 'play'"
    width="8"
    height="9"
    viewBox="0 0 8 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.29517 4.45252L.0311771 8.64639l4e-7-8.387734L7.29517 4.45252z"
      :fill="color"
    />
  </svg>
  <svg
    v-else-if="icon === 'linkedin'"
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.17078 2.92578c-.16407.16406-.34636.28711-.54688.36914-.20052.08203-.41927.12305-.65625.12305-.22786 0-.44433-.04102-.64941-.12305-.20508-.08203-.38965-.20508-.553714-.36914-.164063-.16406-.287109-.34407-.36914-.54004-.082032-.19596-.123047-.41699-.123047-.66308 0-.22787.041015-.43978.123047-.63575C.477417.89095.600463.710938.764526.546875.92859.382812 1.11088.255209 1.3114.164062c.20052-.0911458.41927-.1367182.65625-.1367182.22787 0 .44434.0455724.64942.1367182.20507.091147.38964.21875.55371.382813.16406.164063.28711.341796.36914.533205.08203.19141.12304.4056.12304.64258 0 .24609-.04101.46712-.12304.66308-.08203.19597-.20508.37598-.36914.54004zM10.745 7.16406c-.0912-.10937-.2188-.1914-.3828-.24609-.1641-.05469-.3646-.08203-.60158-.08203-.30078 0-.55371.04557-.75879.13672-.20508.09114-.37142.21875-.49902.38281-.11849.17318-.20736.38281-.2666.62891-.05925.24609-.08887.52864-.08887.84765v4.78517c0 .0364-.00684.0752-.02051.1162-.01367.041-.04329.0843-.08887.1299-.02734.0273-.0638.0524-.10937.0752s-.09115.0342-.13672.0342H5.27625c-.03646 0-.0752-.0114-.11622-.0342l-.12988-.0752c-.02734-.0365-.05241-.0752-.07519-.1162-.02279-.041-.03418-.0843-.03418-.1299V4.78516c0-.03646.01139-.0752.03418-.11621l.07519-.12989c.03646-.02734.0752-.05241.11621-.07519.04102-.02279.08431-.03418.12989-.03418h2.43359c.03646 0 .07519.00455.11621.01367l.0564.01709.04614.02393c.02734.00911.04785.0319.06152.06835l.04785.12305.00342.05469.01026.05469c.00911.03645.01367.0638.01367.08203v.21875c.3099-.30079.67447-.52181 1.09375-.66309.41927-.14128.88414-.21191 1.39454-.21191.5833 0 1.1029.06836 1.5586.20508.4557.13671.8476.35091 1.1758.64257.3281.30079.5742.66537.7382 1.09375.1641.42839.2461.92969.2461 1.50391v5.96095c0 .0364-.0068.0752-.0205.1162-.0136.041-.0433.0843-.0888.1299-.0274.0273-.0638.0524-.1094.0752s-.0912.0342-.1367.0342h-2.5703c-.0365 0-.0752-.0114-.1163-.0342l-.1298-.0752c-.0274-.0365-.0524-.0752-.0752-.1162-.0228-.041-.0342-.0843-.0342-.1299V8.23047c0-.22787-.0205-.43066-.0615-.6084-.0411-.17774-.1026-.3304-.1846-.45801zM3.58093 13.6172V4.78516c0-.04558-.01139-.08887-.03418-.12989-.02278-.04101-.04785-.07975-.07519-.11621l-.12989-.07519c-.04101-.02279-.07975-.03418-.11621-.03418H.709839c-.045573 0-.088867.01139-.129883.03418-.041016.02278-.079752.04785-.116211.07519l-.075195.12989c-.022787.04101-.03418.07975-.03418.11621v8.83204c0 .0456.011393.0889.03418.1299.022786.041.047851.0797.075195.1162l.129883.0752c.041016.0228.079752.0342.116211.0342H3.22546c.04558 0 .08887-.0114.12989-.0342.04101-.0228.07975-.0479.11621-.0752l.07519-.1299c.02279-.041.03418-.0798.03418-.1162z"
      :fill="color"
    />
  </svg>
  <svg
    v-else-if="icon === 'instagram'"
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.29707.00356007L5.93768.00465192c-.23705.00221535-.41633.0052219-.53786.00901968l-.72546.0281982c-.0883.0039876-.17916.0082601-.27259.0128174-.38281.0091146-.70865.0410154-.97753.0957028-.26889.054688-.50814.123047-.71778.205078-.22786.091147-.44661.202799-.65625.334961-.20963.132163-.41015.293945-.60156.485351-.19141.19141-.35091.38965-.478517.59473-.127604.20508-.241536.4261-.341796.66308-.082032.21875-.148112.46029-.198243.72461-.05013.26433-.084309.58789-.102539.97071l-.015381.52124-.027771.75409c-.005981.26916-.009636.65075-.010965 1.14478L.27752 8.33519c.002215.23704.005222.41633.00902.53786l.028198.72546c.003988.0883.00826.17916.012817.27258.009115.38281.041016.70871.095703.97751.054688.2689.123047.5082.205079.7178.091146.2279.202798.4466.334961.6563.132162.2096.293942.4101.485352.6015.19141.1914.38965.3509.59473.4785.20507.1276.4261.2416.66308.3418.21875.0821.46029.1481.72461.1983.26433.0501.58789.0843.9707.1025l.52124.0154.75409.0278c.26917.0059.65076.0096 1.14478.0109l1.78618-.0041c.23704-.0022.41633-.0052.53786-.009l.72546-.0282c.0883-.004.17912-.0082.27262-.0128.3828-.0091.7086-.041.9775-.0957.2689-.0547.5081-.123.7178-.2051.2278-.0911.4466-.2028.6562-.3349.2097-.1322.4102-.294.6016-.4854.1914-.1914.3509-.3896.4785-.5947s.2415-.4261.3418-.6631c.082-.2187.1481-.4603.1982-.7246.0502-.2643.0844-.5879.1026-.97071l.0154-.52124.0277-.75409c.006-.26916.0097-.65075.011-1.14478l-.0041-1.78617c-.0022-.23704-.0052-.41633-.009-.53786l-.0282-.72546c-.004-.0883-.0083-.17916-.0128-.27258-.0091-.38282-.041-.70866-.0957-.97754-.0547-.26888-.1231-.50814-.2051-.71778-.0911-.22786-.2028-.44661-.335-.65625-.1321-.20963-.2939-.41015-.4853-.60156-.1914-.191406-.3897-.35091-.5947-.478515-.2051-.127604-.4261-.241536-.6631-.341797-.2188-.082031-.4603-.148111-.7246-.198242-.2644-.05013-.5879-.0843095-.9707-.1025388L9.62272.0393064 8.86863.0115353C8.71482.00811735 8.5243.00545893 8.29707.00356007zM6.1005 1.26294l2.61247.00095c.1671.00202.29774.00456.39193.00759l.9844.04102c.3554.00911.6312.03646.8271.08203.196.04557.3578.09115.4854.13672.164.0638.3099.139.4375.22559.1276.08658.2461.18457.3554.29394.1185.11849.2211.24154.3077.36914.0865.12761.1572.26888.2119.42383.0547.13672.1048.30306.1504.49902.0455.19597.0774.46712.0957.81348l.0153.53662.0302.85487c.0054.2942.0083.7016.009 1.22221L13.009 8.4401c-.002.1671-.0046.29775-.0076.39193l-.041.98438c-.0091.35549-.0365.63119-.0821.82719-.0455.1959-.0911.3577-.1367.4853-.0638.1641-.139.3099-.2256.4375-.0866.1276-.1845.2461-.2939.3555-.1185.1185-.2415.221-.3692.3076-.1276.0866-.2688.1572-.4238.2119-.1367.0547-.303.1048-.499.1504s-.4671.0775-.8135.0957l-.5366.0154-.85487.0302c-.2942.0053-.7016.0083-1.22221.0089l-1.67016-.0059c-.1671-.002-.29774-.0045-.39192-.0076l-.98438-.041c-.35547-.0091-.63118-.0365-.82715-.082-.19596-.0456-.35774-.0912-.48535-.1367-.16406-.0639-.30989-.139-.4375-.2256-.1276-.0866-.24609-.1846-.35547-.294-.11849-.1185-.22103-.2415-.30761-.3691-.08659-.1276-.15723-.2689-.21192-.4239-.05469-.1367-.10482-.303-.15039-.499-.04557-.1959-.07747-.4671-.0957-.81345l-.01538-.53662-.0302-.85487c-.00531-.2942-.0083-.7016-.00897-1.22221l.00594-1.67015c.00202-.1671.00455-.29775.00759-.39193l.04102-.98438c.00911-.35547.03646-.63118.08203-.82715.04557-.19596.09114-.35774.13672-.48535.0638-.16406.13899-.30989.22558-.4375.08659-.1276.18457-.24609.29395-.35547.11849-.11849.24153-.22102.36914-.30761.1276-.08659.26888-.15723.42383-.21192.13672-.05468.30306-.10481.49902-.15039.19597-.04557.46712-.07747.81348-.0957l.53662-.01538.85487-.03019c.08406-.00152.17735-.00285.27989-.00399zm-.23583 2.41479c.4375-.1914.90689-.28711 1.4082-.28711.5013 0 .9707.09571 1.4082.28711.4375.1823.82031.4375 1.14844.76563.32809.32813.58329.71093.76559 1.14844.1914.4375.2871.9069.2871 1.4082 0 .5013-.0957.9707-.2871 1.4082-.1823.43751-.4375.82031-.76559 1.14844-.32813.32813-.71094.58336-1.14844.76566-.4375.1914-.9069.2871-1.4082.2871-.50131 0-.9707-.0957-1.4082-.2871-.43751-.1823-.82032-.43753-1.14844-.76566-.32813-.32813-.58334-.71093-.76563-1.14844-.1914-.4375-.28711-.9069-.28711-1.4082 0-.5013.09571-.9707.28711-1.4082.18229-.43751.4375-.82031.76563-1.14844.32812-.32813.71093-.58333 1.14844-.76563zm1.4082 5.67383c-.63803 0-1.18945-.23014-1.6543-.69043C5.15372 8.20084 4.92131 7.64714 4.92131 7c0-.63802.23014-1.18945.69042-1.6543.46029-.46484 1.014-.69726 1.66114-.69726.63802 0 1.18945.23014 1.65429.69043.46485.46029.69727 1.01399.69727 1.66113 0 .63802-.23014 1.18945-.69043 1.6543-.46029.46484-1.01399.69726-1.66113.69726zm4.33403-5.50293c.1549-.16862.2324-.36686.2324-.59472 0-.23698-.0798-.43295-.2393-.58789-.1595-.15495-.3532-.23243-.581-.23243-.237 0-.4375.07976-.6016.23926-.1641.15951-.2461.35319-.2461.58106 0 .23698.0843.4375.2529.60156.1687.16406.3669.24609.5948.24609.2369 0 .4329-.08431.5879-.25293z"
      :fill="color"
    />
  </svg>
  <svg
    v-else-if="icon === 'twitter'"
    width="15"
    height="12"
    viewBox="0 0 15 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8516 3.15625v.35547c0 .94792-.1778 1.9095-.5332 2.88476-.3555.96616-.8796 1.84115-1.5723 2.625-.6927.78386-1.54948 1.42642-2.57032 1.92772-1.01172.4922-2.17838.7383-3.5.7383-.40104 0-.79752-.0273-1.18945-.082-.39193-.0547-.77246-.1367-1.1416-.2461-.36915-.1094-.72689-.2461-1.07325-.4102-.346352-.1549-.67903-.3372-.998042-.5469.109375.0092.223306.016.341796.0206.118491.0045.232422.0068.341797.0068.665369 0 1.305659-.1048 1.920899-.3145.61524-.2096 1.16894-.51494 1.66113-.91598-.62891 0-1.18945-.18913-1.68164-.56738-.49219-.37826-.83398-.85449-1.02539-1.42872.09115.02735.18001.0433.2666.04786.08659.00455.18002.00683.28028.00683.13672 0 .2666-.00683.38964-.02051.12305-.01367.24838-.03418.37598-.06152-.65625-.13672-1.20312-.4694-1.64062-.99805-.38889-.46991-.604942-1.00102-.648152-1.59336l-.008102-.27968c.191404.10937.394204.19596.608394.25976.2142.06381.43978.09571.67676.09571-.38281-.2461-.6927-.58106-.92969-1.00489-.236975-.42383-.355464-.88183-.355464-1.37402 0-.25521.036458-.50586.109375-.75195.072919-.2461.173179-.47852.300779-.697269.34636.437499.73828.833979 1.17578 1.189449.43751.35548.9069.66309 1.40821.92286.5013.25976 1.02994.46712 1.58593.62207.56511.15494 1.14388.24609 1.73633.27343-.02734-.10937-.04785-.21875-.06152-.32812-.01367-.10938-.02051-.21875-.02051-.32813 0-.39193.07292-.76562.21875-1.12109.15495-.34636.3623-.64941.62207-.90918.25977-.259767.56283-.462564.90918-.608398C9.17839.389973 9.55208.3125 9.95312.3125c.41928 0 .80888.08203 1.16898.246094.36.164063.6722.382811.9365.656246.3281-.0638.6471-.15266.957-.266598.3099-.113933.6016-.252929.875-.416992-.1094.328127-.2734.6289-.4922.90234-.2187.27344-.4739.5013-.7656.6836.2826-.03646.5606-.09115.834-.16407.2734-.07291.5423-.17317.8066-.30078-.1914.28256-.4078.55143-.6494.80664-.2415.25521-.499.48763-.7724.69727z"
      :fill="color"
    />
  </svg>
  <svg
    v-else-if="icon === 'facebook'"
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.73047 14H2.16016V7.60156H0V5.11328h2.16016V3.28125c0-.53776.07747-1.00716.23242-1.4082.15495-.41016.37142-.75423.64941-1.03223.278-.277996.61296-.485351 1.00489-.62207C4.44792.0729159 4.88541 0 5.35938 0c.34179 0 .65539.00640863.94079.019226l.276.0149537c.35547.0227866.58789.0478514.69727.0751953V2.32422h-1.3125c-.51954 0-.85449.11165-1.00489.33496-.15039.22331-.22558.51269-.22558.86816v1.58594h2.46094l-.32813 2.48828H4.73047V14z"
      :fill="color"
    />
  </svg>
  <svg
    v-else-if="icon === 'github'"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fill-rule="evenodd" d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z" :fill="color"></path>
  </svg>
  <svg
    v-else-if="icon === 'briefcase'"
    width="25"
    height="27"
    viewBox="0 0 25 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      :stroke="stroke"
      stroke-width="1.94343"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path
        d="M8.59187 23.623h7.81823c3.0187 0 5.4659-2.4471 5.4659-5.4659V13.498H3.12598v4.6591c0 3.0188 2.44716 5.4659 5.46589 5.4659z"
        :fill="color"
      />
      <path
        d="M8.33398 6.7489v-.33333c0-2.30119 1.86552-4.16667 4.16672-4.16667v0c2.3011 0 4.1666 1.86548 4.1666 4.16667v.33333M8.33398 12.3738v2.25M16.6672 12.3738v2.25"
      />
      <rect
        x="2.08423"
        y="6.74829"
        width="20.8333"
        height="6.75"
        rx="2.69651"
        :fill="color"
      />
    </g>
  </svg>
  <svg
    v-else-if="icon === 'target'"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5381 22.1096c5.3268 0 9.6451-4.3183 9.6451-9.6451 0-5.3268-4.3183-9.64504-9.6451-9.64504-5.32679 0-9.64503 4.31824-9.64503 9.64504 0 5.3268 4.31824 9.6451 9.64503 9.6451z"
      :fill="color"
      :stroke="stroke"
      stroke-width="1.38889"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.537 18.2502c3.1961 0 5.7871-2.5909 5.7871-5.787 0-3.19611-2.591-5.78705-5.7871-5.78705-3.19606 0-5.787 2.59094-5.787 5.78705 0 3.1961 2.59094 5.787 5.787 5.787z"
      :stroke="stroke"
      stroke-width="1.38889"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.5374 14.392c1.0654 0 1.929-.8637 1.929-1.9291 0-1.0653-.8636-1.929-1.929-1.929s-1.929.8637-1.929 1.929c0 1.0654.8636 1.9291 1.929 1.9291z"
      :stroke="stroke"
      stroke-width="1.38889"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <svg
    v-else-if="icon === 'present'"
    width="29"
    height="29"
    viewBox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0)">
      <rect
        x="3.58276"
        y="8.36011"
        width="21.4983"
        height="4.7774"
        rx="1.19435"
        :fill="color"
        :stroke="stroke"
        stroke-width="1.79153"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.97168 13.1376H22.6926v9.5548c0 1.3192-1.0695 2.3887-2.3887 2.3887H8.36038c-1.31924 0-2.3887-1.0695-2.3887-2.3887v-9.5548z"
        :fill="color"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.06202 5.37432c0-1.15434.93577-2.09012 2.09008-2.09012h.0959c.9653 0 1.8163.6332 2.0937 1.55781l.7867 2.62242h-2.9763c-1.15431 0-2.09008-.93578-2.09008-2.09011zm2.09008-3.88164c-2.14374 0-3.88161 1.73786-3.88161 3.88164 0 2.14377 1.73787 3.88164 3.88161 3.88164h3.2844v2.98594H5.97145c-.49472 0-.89577.401-.89577.8958v9.5548c0 1.8139 1.47051 3.2844 3.28447 3.2844H20.3037c1.8139 0 3.2844-1.4705 3.2844-3.2844v-9.5548c0-.4948-.401-.8958-.8957-.8958H15.228V9.25596h3.2844c2.1438 0 3.8817-1.73787 3.8817-3.88164 0-2.14378-1.7379-3.88164-3.8817-3.88164h-.0958c-1.7565 0-3.305 1.15214-3.8097 2.83454l-.2746.91533-.2746-.91533c-.5047-1.6824-2.0533-2.83454-3.8097-2.83454h-.0959zm3.2844 12.54072H6.86721v8.6591c0 .8245.66841 1.4929 1.49294 1.4929h5.07635v-10.152zm1.7915 10.152v-10.152h6.5686v8.6591c0 .8245-.6684 1.4929-1.4929 1.4929H15.228zm5.3745-18.81108c0-1.15434-.9358-2.09012-2.0901-2.09012h-.0958c-.9653 0-1.8164.6332-2.0938 1.55781l-.7867 2.62242h2.9763c1.1543 0 2.0901-.93578 2.0901-2.09011z"
        :fill="stroke"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <path fill="#fff" d="M0 0h28.7529v28.7529H0z" />
      </clipPath>
    </defs>
  </svg>
  <svg
    v-else-if="icon === 'lightning'"
    width="23"
    height="25"
    viewBox="0 0 23 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.7743 2L2 14.9291h9.6968l-1.0774 8.6195 10.7743-12.9292h-9.6969L12.7743 2z"
      :fill="color"
      :stroke="stroke"
      stroke-width="2.15486"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <svg
    v-else-if="icon === 'user'"
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.4621 12.4614c2.8676 0 5.1923-2.3247 5.1923-5.19231 0-2.86763-2.3247-5.19231-5.1923-5.19231-2.86765 0-5.19232 2.32468-5.19232 5.19231 0 2.86761 2.32467 5.19231 5.19232 5.19231z"
      :fill="color"
      :stroke="stroke"
      stroke-width="1.66154"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.15432 19.727c-.00148-.4622.08606-.9188.25602-1.3352.53333-1.2595 2.03735-1.9271 3.28536-2.2293.90006-.2268 1.81255-.3784 2.7307-.4535 1.6998-.1763 3.4095-.1763 5.1094 0 .918.076 1.8305.2275 2.7306.4535 1.2481.3022 2.7521.9068 3.2854 2.2293.3418.8488.3418 1.8341 0 2.6829-.5333 1.3225-2.0373 1.9271-3.2854 2.2168-.899.2361-1.8118.3919-2.7306.466-1.3836.1385-2.7736.1637-4.1601.0756-.32 0-.6293 0-.9493-.0756-.91544-.0732-1.82477-.229-2.72004-.466-1.25867-.2897-2.75202-.8943-3.29602-2.2168-.16909-.4212-.25655-.8816-.25602-1.3477z"
      :fill="color"
      :stroke="stroke"
      stroke-width="1.66154"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <svg
    v-else-if="icon === 'wallet'"
    width="26"
    height="24"
    viewBox="0 0 26 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.56529 1H18.2427c3.5801 0 6.4825 2.90239 6.4825 6.48253v8.86587c0 3.5802-2.9024 6.4826-6.4825 6.4826H7.56529c-3.58014 0-6.48253-2.9024-6.48253-6.4826V7.48253C1.08276 3.90239 3.98515 1 7.56529 1z"
      :fill="color"
      :stroke="stroke"
      stroke-width="1.52211"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24.7251 15.0775h-5.001c-1.8362-.0011-3.3245-1.4884-3.3257-3.3246 0-1.83621 1.4895-3.32343 3.3257-3.32456h5.001"
      :fill="color"
    />
    <path
      d="M24.7251 15.0775h-5.001c-1.8362-.0011-3.3245-1.4884-3.3257-3.3246 0-1.83621 1.4895-3.32343 3.3257-3.32456h5.001M20.2906 11.6769h-.3851"
      :stroke="stroke"
      stroke-width="1.52211"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <svg
    v-else-if="icon === 'rocket'"
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0)">
      <path
        d="M10.5 25.5l-3 .5v-3.5l2-2L8 19v-1l-2.5-2.5 4.5-4h3.5l4.5-3L21 7h5.5l-.5 4-1 3-3 5-.5 4.5-4 3.5-2-2.5-1.5.5-1-1.5-2.5 2z"
        :fill="color"
      />
      <path
        d="M22.3714 20.5976v-1.3579c1.7399-1.9945 3.0554-4.3285 3.8616-6.9171l.0425.0425.2546-1.0185.0849-.3395c.2546-1.10334.3395-2.29154.3395-3.47975-.0425-.80629-.679-1.44282-1.4853-1.48526-1.1458-.04244-2.334.04244-3.4797.33949l-.3395.08487-1.0185.25462.0424.04243c-2.5461.76385-4.9225 2.1218-6.917 3.8617l-1.4004-.0425c-2.0794-.0424-4.11631.8912-5.47426 2.5038l-1.99449 2.4188 2.75834 2.5886c-.08487.1698-.12731.2971-.25462.4244l-.21217.3819 1.31551 1.3155c-.29705.2122-.5941.4244-.84872.679-1.52769 1.5277-1.31551 4.7952-1.27308 5.1772v.5092h.50923c.38193.0424 3.64946.2546 5.17716-1.2731.2546-.2546.4668-.5516.679-.8487l1.3155 1.3155.3819-.2122c.1698-.0848.2971-.1273.4244-.2546l2.5886 2.7584 2.4189-1.9945c1.655-1.3155 2.5885-3.3525 2.5037-5.4743zM6.50032 15.4204l1.31552-1.5701c1.10333-1.3579 2.80076-2.1218 4.58306-2.0369h.0849c-.0849.0849-.1698.1697-.2546.2546-1.4853 1.4853-2.8008 3.1403-3.94657 4.965l-1.78231-1.6126zM25.3843 7.2303c.1698 0 .2971.1273.3395.33948.0425.80629 0 1.61257-.1697 2.37642l-2.5462-2.54616c.8063-.12731 1.5701-.21218 2.3764-.16974zM11.2532 24.4169c-.8063.8063-2.63108.9336-3.69198.976-.04244-1.0609.16974-2.8857.97603-3.6919.25461-.2546.55166-.4668.89115-.6366l2.5037 2.5037c-.2122.2971-.4243.5942-.6789.8488zm3.0553-.0849l-5.68638-5.6864c1.18821-2.1218 2.63098-4.0739 4.32848-5.7713 2.3764-2.4613 5.3469-4.24361 8.6145-5.21964l3.6919 3.69194c-.9336 3.31-2.7159 6.2805-5.2196 8.6145-1.655 1.7399-3.6071 3.1827-5.7289 4.3709zm4.8377.8487l-1.6125 1.2731-1.6126-1.6974c1.8672-1.1034 3.5222-2.4189 5.0075-3.9042l.2546-.2546v.0849c.0424 1.655-.7214 3.3524-2.037 4.4982zm1.4004-12.7732c-1.1882-1.1882-3.0554-1.1882-4.2436 0-1.1882 1.1882-1.1882 3.0554 0 4.2436 1.1882 1.1882 3.0554 1.1882 4.2436 0 1.1882-1.1882 1.1882-3.0554 0-4.2436zm-3.3948 3.3949c-.7215-.7214-.7215-1.8248 0-2.5462.7214-.7214 1.8247-.7214 2.5461 0s.7214 1.8248 0 2.5462c-.679.6789-1.8247.7214-2.5461 0z"
        :fill="stroke"
      />
    </g>
    <defs>
      <clipPath id="clip0"><path fill="#fff" d="M0 0h33v33H0z" /></clipPath>
    </defs>
  </svg>
  <svg
    v-else-if="icon === 'plus'"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5635 17.1419v10.2666h6.8807V17.1419h9.939v-6.5531h-9.939V.322199h-6.8807V10.5888H.569922v6.5531H10.5635z"
      :fill="color"
    />
  </svg>
  <svg
    v-else-if="icon === 'menu-down'"
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5 6L.669873 1.4e-7 9.33013 9e-7 5 6z" :fill="color" />
  </svg>
  <svg
    v-else-if="icon === 'menu-up'"
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5 0l4.33013 6H.669873L5 0z" :fill="color" />
  </svg>
  <svg
    v-else-if="icon === 'browser'"
    width="39"
    height="37"
    viewBox="0 0 39 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.0482 4.03454h-.0835c-1.31574-.00006-2.42502-.0001-3.30823.11864-.93707.12599-1.80087.4055-2.4973 1.10193-.69644.69644-.97595 1.56023-1.10193 2.4973-.11875.88322-.1187 1.99249-.11865 3.30829v14.8785c-.00005 1.3157-.0001 2.425.11865 3.3082.12598.9371.40549 1.8009 1.10193 2.4973.69643.6965 1.56023.976 2.49729 1.102.88319.1187 1.99242.1187 3.30814.1186h17.8211c1.3157.0001 2.4249.0001 3.3081-.1186.9371-.126 1.8009-.4055 2.4973-1.102.6964-.6964.9759-1.5602 1.1019-2.4973.1188-.8832.1187-1.9924.1187-3.3081V11.0605c0-1.31567.0001-2.4249-.1187-3.30809-.126-.93707-.4055-1.80086-1.1019-2.4973-.6964-.69643-1.5602-.97594-2.4973-1.10193-.8832-.11874-1.9925-.1187-3.3083-.11864H11.0482zm22.3135 8.82696v-1.7173c0-1.4217-.0026-2.3647-.0968-3.06533-.0895-.66539-.2409-.926-.4062-1.09135-.1654-.16534-.426-.31672-1.0914-.40618-.7006-.0942-1.6436-.0968-3.0652-.0968H11.0482c-1.42164 0-2.36465.0026-3.06528.0968-.66539.08946-.92599.24084-1.09134.40618-.16535.16535-.31673.42596-.40619 1.09135-.0942.70063-.0968 1.64363-.0968 3.06533v1.7173H33.3617zm-26.97311 2.45H33.3617v10.5442c0 1.4216-.0026 2.3646-.0968 3.0653-.0895.6654-.2409.926-.4062 1.0913-.1654.1654-.426.3167-1.0914.4062-.7006.0942-1.6436.0968-3.0652.0968H11.0482c-1.42165 0-2.36465-.0026-3.06528-.0968-.66539-.0895-.92599-.2408-1.09134-.4062-.16535-.1653-.31673-.4259-.40619-1.0913-.0942-.7007-.0968-1.6437-.0968-3.0653V15.3115z"
      :fill="color"
    />
    <circle cx="9.57662" cy="9.67306" r="1.47115" :fill="color" />
    <circle cx="13.9907" cy="9.67306" r="1.47115" :fill="color" />
    <circle cx="18.4038" cy="9.67306" r="1.47115" :fill="color" />
  </svg>
  <svg
    v-else-if="icon === 'monitor'"
    width="37"
    height="37"
    viewBox="0 0 37 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.833 4.625H6.16634c-1.70288 0-3.08333 1.38046-3.08333 3.08333V23.125c0 1.7029 1.38045 3.0833 3.08333 3.0833H30.833c1.7029 0 3.0833-1.3804 3.0833-3.0833V7.70833c0-1.70287-1.3804-3.08333-3.0833-3.08333zM12.333 32.375h12.3333M18.5 26.2085v6.1667"
      :stroke="color"
      stroke-width="2.74074"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <svg
    v-else-if="icon === 'smartphone'"
    width="28"
    height="34"
    viewBox="0 0 28 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.8722 3.57886H6.81203C5.25899 3.57886 4 4.86074 4 6.44202V29.3473c0 1.5813 1.25899 2.8631 2.81203 2.8631H20.8722c1.553 0 2.812-1.2818 2.812-2.8631V6.44202c0-1.58128-1.259-2.86316-2.812-2.86316z"
      stroke="#30D6BB"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14 26.842h.0202"
      :stroke="color"
      stroke-width="2.66697"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <svg
    v-else-if="icon === 'document'"
    width="30"
    height="33"
    viewBox="0 0 30 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.5791 23.1458H9.2373M20.5791 16.5691H9.2373M13.5651 10.0078H9.2373"
      stroke="#30D6BB"
      stroke-width="2.48796"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      clip-rule="evenodd"
      d="M20.8811 1.97998s-12.05971.00628-12.07856.00628c-4.33566.02671-7.02031 2.87945-7.02031 7.23081V23.663c0 4.3733 2.70507 7.2371 7.07843 7.2371 0 0 12.05814-.0047 12.07854-.0047 4.3357-.0268 7.0219-2.8811 7.0219-7.2324V9.21707c0-4.37336-2.7066-7.23709-7.08-7.23709z"
      :stroke="color"
      stroke-width="2.48796"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <svg v-else-if="icon === 'arrow-down'" width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2l8 8 8-8" :stroke="color" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round"/></svg>
  <svg v-else-if="icon === 'message'" width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23.6245 16.875c0 .5967-.2371 1.169-.6591 1.591-.4219.4219-.9942.659-1.5909.659H7.87445l-4.5 4.5v-18c0-.59674.23705-1.16903.65901-1.59099.42196-.42196.99425-.65901 1.59099-.65901H21.3745c.5967 0 1.169.23705 1.5909.65901.422.42196.6591.99425.6591 1.59099v11.25z" stroke="#2355C3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
  <svg v-else-if="icon === 'video-camera'" width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M27.7915 8.45837L19.3331 14.5l8.4584 6.0417V8.45837zM16.9163 6.04169H3.62467c-1.33468 0-2.41666 1.08198-2.41666 2.41666V20.5417c0 1.3347 1.08198 2.4167 2.41666 2.4167H16.9163c1.3347 0 2.4167-1.082 2.4167-2.4167V8.45835c0-1.33468-1.082-2.41666-2.4167-2.41666z" stroke="#2355C3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
  <svg v-else-if="icon === 'wifi'" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.167 10.458a9.167 9.167 0 0111.733 0M1.183 7.5a13.333 13.333 0 0117.634 0M7.108 13.425a5 5 0 015.792 0" stroke="#2355C3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M10 16.667h.008" stroke="#2355C3" stroke-width="2.217" stroke-linecap="round" stroke-linejoin="round"/></svg>
    <svg v-else-if="icon === 'wifi-off'" width="20" height="20" viewBox="0 0 20 20"  fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 3l13.5 13.5M13.933 9.217c.683.333 1.321.75 1.9 1.241M4.167 10.458a9.117 9.117 0 014.308-1.991M8.925 4.208A13.333 13.333 0 0118.817 7.5M1.183 7.5A13.258 13.258 0 015.1 5.1M7.108 13.425a5 5 0 015.792 0M10 16.667h.01" stroke="#2355C3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
    <svg v-else-if="icon === 'poll'" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.356 16.258H4.243M12.872 6.509h-8.63M16.322 11.708H4.242" stroke="#2355C3" stroke-width="2.217" stroke-linecap="round" stroke-linejoin="round"/></svg>
    <svg v-else-if="icon === 'list'" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.667 5H17.5M6.667 10H17.5M6.667 15H17.5M2.5 5h.01M2.5 10h.01M2.5 15h.01" stroke="#2355C3" stroke-width="2.016" stroke-linecap="round" stroke-linejoin="round"/></svg>
    <svg v-else-if="icon === 'globe'" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.9091 27.334c6.8619 0 12.4245-5.5627 12.4245-12.4245 0-6.86188-5.5626-12.42451-12.4245-12.42451-6.86185 0-12.42448 5.56263-12.42448 12.42451 0 6.8618 5.56263 12.4245 12.42448 12.4245zM2.48462 14.9094H27.3336" stroke="#2355C3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M14.9094 2.48499c3.1077 3.40226 4.8738 7.81751 4.9698 12.42451-.096 4.6069-1.8621 9.0222-4.9698 12.4245-3.1077-3.4023-4.8738-7.8176-4.96982-12.4245.09602-4.607 1.86212-9.02225 4.96982-12.42451v0z" stroke="#2355C3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
</template>
<script>
export default {
  props: ["icon", "color", "stroke"],
};
</script>
